"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.allopurinolActiveIngredientMessages = exports.statinIntakeTypeMessages = exports.trombocytaAggregationInhibitorIntakeTypeMessages = exports.anticoagulantIntakeTypeMessages = exports.antiarrhythmicAgentIntakeTypeMessages = exports.diureticIntakeTypeMessages = exports.ivabradineIntakeTypeMessages = exports.ivabradineActiveIngredientMessages = exports.arniIntakeTypeMessages = exports.arniActiveIngredientMessages = exports.mraIntakeTypeMessages = exports.mraActiveIngredientMessages = exports.arbIntakeTypeMessages = exports.arbActiveIngredientMessages = exports.bblIntakeTypeMessages = exports.bblActiveIngredientMessages = exports.aceiIntakeTypeMessages = exports.aceiActiveIngredientMessages = exports.OtherIntakeType = exports.AntibioticIntakeType = exports.LevosimendanIntakeType = exports.LevosimendanActiveIngredient = exports.PdeInhibitorIntakeType = exports.PdeInhibitorActiveIngredient = exports.NorepinephrineIntakeType = exports.NorepinephrineActiveIngredient = exports.DobutamineIntakeType = exports.DobutamineActiveIngredient = exports.DopamineIntakeType = exports.DopamineActiveIngredient = exports.DigitalisIntakeType = exports.AllopurinolIntakeType = exports.AllopurinolActiveIngredient = exports.StatinIntakeType = exports.TrombocytaAggregationInhibitorIntakeType = exports.AnticoagulantIntakeType = exports.AntiarrhythmicAgentIntakeType = exports.DiureticIntakeType = exports.IvabradineIntakeType = exports.IvabradineActiveIngredient = exports.ArniIntakeType = exports.ArniActiveIngredient = exports.MraIntakeType = exports.MraActiveIngredient = exports.ArbIntakeType = exports.ArbActiveIngredient = exports.BblIntakeType = exports.BblActiveIngredient = exports.AceiIntakeType = exports.AceiActiveIngredient = void 0;
exports.validator = exports.otherIntakeTypeMessages = exports.antibioticIntakeTypeMessages = exports.levosimendanIntakeTypeMessages = exports.levosimendanActiveIngredientMessages = exports.pdeInhibitorIntakeTypeMessages = exports.pdeInhibitorActiveIngredientMessages = exports.norepinephrineIntakeTypeMessages = exports.norepinephrineActiveIngredientMessages = exports.dobutamineIntakeTypeMessages = exports.dobutamineActiveIngredientMessages = exports.dopamineIntakeTypeMessages = exports.dopamineActiveIngredientMessages = exports.digitalisIntakeTypeMessages = exports.allopurinolIntakeTypeMessages = void 0;
const schema_1 = require("../../../schema");
var AceiActiveIngredient;
(function (AceiActiveIngredient) {
    AceiActiveIngredient["CAPTOPRIL"] = "captopril";
    AceiActiveIngredient["ENALAPRIL"] = "enalapril";
    AceiActiveIngredient["LISINOPRIL"] = "lisinopril";
    AceiActiveIngredient["RAMIPRIL"] = "ramipril";
    AceiActiveIngredient["TRANDOLAPRIL"] = "trandolapril";
    AceiActiveIngredient["OTHER"] = "other";
})(AceiActiveIngredient || (exports.AceiActiveIngredient = AceiActiveIngredient = {}));
var AceiIntakeType;
(function (AceiIntakeType) {
    AceiIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    AceiIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(AceiIntakeType || (exports.AceiIntakeType = AceiIntakeType = {}));
var BblActiveIngredient;
(function (BblActiveIngredient) {
    BblActiveIngredient["BISOPROLOL"] = "bisoprolol";
    BblActiveIngredient["CARVEDILOL"] = "carvedilol";
    BblActiveIngredient["METOPROLOL_SUCCINATE"] = "metoprolol_succinate";
    BblActiveIngredient["NEBIVOLOL"] = "nebivolol";
    BblActiveIngredient["OTHER"] = "other";
})(BblActiveIngredient || (exports.BblActiveIngredient = BblActiveIngredient = {}));
var BblIntakeType;
(function (BblIntakeType) {
    BblIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    BblIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(BblIntakeType || (exports.BblIntakeType = BblIntakeType = {}));
var ArbActiveIngredient;
(function (ArbActiveIngredient) {
    ArbActiveIngredient["CANDESARTAN"] = "candesartan";
    ArbActiveIngredient["VALSARTAN"] = "valsartan";
    ArbActiveIngredient["LOSARTAN"] = "losartan";
    ArbActiveIngredient["OTHER"] = "other";
})(ArbActiveIngredient || (exports.ArbActiveIngredient = ArbActiveIngredient = {}));
var ArbIntakeType;
(function (ArbIntakeType) {
    ArbIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    ArbIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(ArbIntakeType || (exports.ArbIntakeType = ArbIntakeType = {}));
var MraActiveIngredient;
(function (MraActiveIngredient) {
    MraActiveIngredient["EPLERENON"] = "eplerenon";
    MraActiveIngredient["SPIRONOLACTON"] = "spironolacton";
    MraActiveIngredient["OTHER"] = "other";
})(MraActiveIngredient || (exports.MraActiveIngredient = MraActiveIngredient = {}));
var MraIntakeType;
(function (MraIntakeType) {
    MraIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    MraIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(MraIntakeType || (exports.MraIntakeType = MraIntakeType = {}));
var ArniActiveIngredient;
(function (ArniActiveIngredient) {
    ArniActiveIngredient["SACUBITRIL_VALSARTAN"] = "sacubitril_valsartan";
    ArniActiveIngredient["OTHER"] = "other";
})(ArniActiveIngredient || (exports.ArniActiveIngredient = ArniActiveIngredient = {}));
var ArniIntakeType;
(function (ArniIntakeType) {
    ArniIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    ArniIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(ArniIntakeType || (exports.ArniIntakeType = ArniIntakeType = {}));
var IvabradineActiveIngredient;
(function (IvabradineActiveIngredient) {
    IvabradineActiveIngredient["IVABRADINE"] = "ivabradine";
})(IvabradineActiveIngredient || (exports.IvabradineActiveIngredient = IvabradineActiveIngredient = {}));
var IvabradineIntakeType;
(function (IvabradineIntakeType) {
    IvabradineIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    IvabradineIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(IvabradineIntakeType || (exports.IvabradineIntakeType = IvabradineIntakeType = {}));
var DiureticIntakeType;
(function (DiureticIntakeType) {
    DiureticIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    DiureticIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(DiureticIntakeType || (exports.DiureticIntakeType = DiureticIntakeType = {}));
var AntiarrhythmicAgentIntakeType;
(function (AntiarrhythmicAgentIntakeType) {
    AntiarrhythmicAgentIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    AntiarrhythmicAgentIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(AntiarrhythmicAgentIntakeType || (exports.AntiarrhythmicAgentIntakeType = AntiarrhythmicAgentIntakeType = {}));
var AnticoagulantIntakeType;
(function (AnticoagulantIntakeType) {
    AnticoagulantIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    AnticoagulantIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(AnticoagulantIntakeType || (exports.AnticoagulantIntakeType = AnticoagulantIntakeType = {}));
var TrombocytaAggregationInhibitorIntakeType;
(function (TrombocytaAggregationInhibitorIntakeType) {
    TrombocytaAggregationInhibitorIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    TrombocytaAggregationInhibitorIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(TrombocytaAggregationInhibitorIntakeType || (exports.TrombocytaAggregationInhibitorIntakeType = TrombocytaAggregationInhibitorIntakeType = {}));
var StatinIntakeType;
(function (StatinIntakeType) {
    StatinIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    StatinIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(StatinIntakeType || (exports.StatinIntakeType = StatinIntakeType = {}));
var AllopurinolActiveIngredient;
(function (AllopurinolActiveIngredient) {
    AllopurinolActiveIngredient["ALLOPURINOL"] = "allopurinol";
})(AllopurinolActiveIngredient || (exports.AllopurinolActiveIngredient = AllopurinolActiveIngredient = {}));
var AllopurinolIntakeType;
(function (AllopurinolIntakeType) {
    AllopurinolIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    AllopurinolIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(AllopurinolIntakeType || (exports.AllopurinolIntakeType = AllopurinolIntakeType = {}));
var DigitalisIntakeType;
(function (DigitalisIntakeType) {
    DigitalisIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    DigitalisIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(DigitalisIntakeType || (exports.DigitalisIntakeType = DigitalisIntakeType = {}));
var DopamineActiveIngredient;
(function (DopamineActiveIngredient) {
    DopamineActiveIngredient["DOPAMINE"] = "dopamine";
})(DopamineActiveIngredient || (exports.DopamineActiveIngredient = DopamineActiveIngredient = {}));
var DopamineIntakeType;
(function (DopamineIntakeType) {
    DopamineIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    DopamineIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(DopamineIntakeType || (exports.DopamineIntakeType = DopamineIntakeType = {}));
var DobutamineActiveIngredient;
(function (DobutamineActiveIngredient) {
    DobutamineActiveIngredient["DOBUTAMINE"] = "dobutamine";
})(DobutamineActiveIngredient || (exports.DobutamineActiveIngredient = DobutamineActiveIngredient = {}));
var DobutamineIntakeType;
(function (DobutamineIntakeType) {
    DobutamineIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    DobutamineIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(DobutamineIntakeType || (exports.DobutamineIntakeType = DobutamineIntakeType = {}));
var NorepinephrineActiveIngredient;
(function (NorepinephrineActiveIngredient) {
    NorepinephrineActiveIngredient["NOREPINEPHRINE"] = "norepinephrine";
})(NorepinephrineActiveIngredient || (exports.NorepinephrineActiveIngredient = NorepinephrineActiveIngredient = {}));
var NorepinephrineIntakeType;
(function (NorepinephrineIntakeType) {
    NorepinephrineIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    NorepinephrineIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(NorepinephrineIntakeType || (exports.NorepinephrineIntakeType = NorepinephrineIntakeType = {}));
var PdeInhibitorActiveIngredient;
(function (PdeInhibitorActiveIngredient) {
    PdeInhibitorActiveIngredient["PDE_INHIBITOR"] = "pdeInhibitor";
})(PdeInhibitorActiveIngredient || (exports.PdeInhibitorActiveIngredient = PdeInhibitorActiveIngredient = {}));
var PdeInhibitorIntakeType;
(function (PdeInhibitorIntakeType) {
    PdeInhibitorIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    PdeInhibitorIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(PdeInhibitorIntakeType || (exports.PdeInhibitorIntakeType = PdeInhibitorIntakeType = {}));
var LevosimendanActiveIngredient;
(function (LevosimendanActiveIngredient) {
    LevosimendanActiveIngredient["LEVOSIMENDAN"] = "levosimendan";
})(LevosimendanActiveIngredient || (exports.LevosimendanActiveIngredient = LevosimendanActiveIngredient = {}));
var LevosimendanIntakeType;
(function (LevosimendanIntakeType) {
    LevosimendanIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    LevosimendanIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(LevosimendanIntakeType || (exports.LevosimendanIntakeType = LevosimendanIntakeType = {}));
var AntibioticIntakeType;
(function (AntibioticIntakeType) {
    AntibioticIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    AntibioticIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(AntibioticIntakeType || (exports.AntibioticIntakeType = AntibioticIntakeType = {}));
var OtherIntakeType;
(function (OtherIntakeType) {
    OtherIntakeType["ORAL_ROUTE"] = "ORAL_ROUTE";
    OtherIntakeType["INTRAVENOUS"] = "INTRAVENOUS";
})(OtherIntakeType || (exports.OtherIntakeType = OtherIntakeType = {}));
exports.aceiActiveIngredientMessages = {
    [AceiActiveIngredient.CAPTOPRIL]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.aceiActiveIngredient.CAPTOPRIL",
        defaultMessage: "Captopril"
    },
    [AceiActiveIngredient.ENALAPRIL]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.aceiActiveIngredient.ENALAPRIL",
        defaultMessage: "Enalapril"
    },
    [AceiActiveIngredient.LISINOPRIL]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.aceiActiveIngredient.LISINOPRIL",
        defaultMessage: "Lisinopril"
    },
    [AceiActiveIngredient.RAMIPRIL]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.aceiActiveIngredient.RAMIPRIL",
        defaultMessage: "Ramipril"
    },
    [AceiActiveIngredient.TRANDOLAPRIL]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.aceiActiveIngredient.TRANDOLAPRIL",
        defaultMessage: "Trandolapril"
    },
    [AceiActiveIngredient.OTHER]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.aceiActiveIngredient.OTHER",
        defaultMessage: "Egyéb"
    }
};
exports.aceiIntakeTypeMessages = {
    [AceiIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.aceiIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [AceiIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.aceiIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.bblActiveIngredientMessages = {
    [BblActiveIngredient.BISOPROLOL]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.bblActiveIngredient.BISOPROLOL",
        defaultMessage: "Bisoprolol"
    },
    [BblActiveIngredient.CARVEDILOL]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.bblActiveIngredient.CARVEDILOL",
        defaultMessage: "Carvedilol"
    },
    [BblActiveIngredient.METOPROLOL_SUCCINATE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.bblActiveIngredient.METOPROLOL_SUCCINATE",
        defaultMessage: "Metoprolol succinate"
    },
    [BblActiveIngredient.NEBIVOLOL]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.bblActiveIngredient.NEBIVOLOL",
        defaultMessage: "Nebivolol"
    },
    [BblActiveIngredient.OTHER]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.bblActiveIngredient.OTHER",
        defaultMessage: "Egyéb"
    }
};
exports.bblIntakeTypeMessages = {
    [BblIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.bblIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [BblIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.bblIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.arbActiveIngredientMessages = {
    [ArbActiveIngredient.CANDESARTAN]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.arbActiveIngredient.CANDESARTAN",
        defaultMessage: "Candesartan"
    },
    [ArbActiveIngredient.VALSARTAN]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.arbActiveIngredient.VALSARTAN",
        defaultMessage: "Valsartan"
    },
    [ArbActiveIngredient.LOSARTAN]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.arbActiveIngredient.LOSARTAN",
        defaultMessage: "Losartan"
    },
    [ArbActiveIngredient.OTHER]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.arbActiveIngredient.OTHER",
        defaultMessage: "Egyéb"
    }
};
exports.arbIntakeTypeMessages = {
    [ArbIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.arbIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [ArbIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.arbIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.mraActiveIngredientMessages = {
    [MraActiveIngredient.EPLERENON]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.mraActiveIngredient.EPLERENON",
        defaultMessage: "Eplerenon"
    },
    [MraActiveIngredient.SPIRONOLACTON]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.mraActiveIngredient.SPIRONOLACTON",
        defaultMessage: "Spironolacton"
    },
    [MraActiveIngredient.OTHER]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.mraActiveIngredient.OTHER",
        defaultMessage: "Egyéb"
    }
};
exports.mraIntakeTypeMessages = {
    [MraIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.mraIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [MraIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.mraIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.arniActiveIngredientMessages = {
    [ArniActiveIngredient.SACUBITRIL_VALSARTAN]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.arniActiveIngredient.SACUBITRIL_VALSARTAN",
        defaultMessage: "Sacubitril/valsartan"
    },
    [ArniActiveIngredient.OTHER]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.arniActiveIngredient.OTHER",
        defaultMessage: "Egyéb"
    }
};
exports.arniIntakeTypeMessages = {
    [ArniIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.arniIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [ArniIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.arniIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.ivabradineActiveIngredientMessages = {
    [IvabradineActiveIngredient.IVABRADINE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.ivabradineActiveIngredient.IVABRADINE",
        defaultMessage: "Ivabradine"
    }
};
exports.ivabradineIntakeTypeMessages = {
    [IvabradineIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.ivabradineIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [IvabradineIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.ivabradineIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.diureticIntakeTypeMessages = {
    [DiureticIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.diureticIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [DiureticIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.diureticIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.antiarrhythmicAgentIntakeTypeMessages = {
    [AntiarrhythmicAgentIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.antiarrhythmicAgentIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [AntiarrhythmicAgentIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.antiarrhythmicAgentIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.anticoagulantIntakeTypeMessages = {
    [AnticoagulantIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.anticoagulantIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [AnticoagulantIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.anticoagulantIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.trombocytaAggregationInhibitorIntakeTypeMessages = {
    [TrombocytaAggregationInhibitorIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.trombocytaAggregationInhibitorIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [TrombocytaAggregationInhibitorIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.trombocytaAggregationInhibitorIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.statinIntakeTypeMessages = {
    [StatinIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.statinIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [StatinIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.statinIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.allopurinolActiveIngredientMessages = {
    [AllopurinolActiveIngredient.ALLOPURINOL]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.allopurinolActiveIngredient.ALLOPURINOL",
        defaultMessage: "Allopurinol"
    }
};
exports.allopurinolIntakeTypeMessages = {
    [AllopurinolIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.allopurinolIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [AllopurinolIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.allopurinolIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.digitalisIntakeTypeMessages = {
    [DigitalisIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.digitalisIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [DigitalisIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.digitalisIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.dopamineActiveIngredientMessages = {
    [DopamineActiveIngredient.DOPAMINE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.dopamineActiveIngredient.DOPAMINE",
        defaultMessage: "Dompamin"
    }
};
exports.dopamineIntakeTypeMessages = {
    [DopamineIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.dopamineIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [DopamineIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.dopamineIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.dobutamineActiveIngredientMessages = {
    [DobutamineActiveIngredient.DOBUTAMINE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.dobutamineActiveIngredient.DOBUTAMINE",
        defaultMessage: "Dobutamin"
    }
};
exports.dobutamineIntakeTypeMessages = {
    [DobutamineIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.dobutamineIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [DobutamineIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.dobutamineIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.norepinephrineActiveIngredientMessages = {
    [NorepinephrineActiveIngredient.NOREPINEPHRINE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.norepinephrineActiveIngredient.NOREPINEPHRINE",
        defaultMessage: "(Nor)adrenalin"
    }
};
exports.norepinephrineIntakeTypeMessages = {
    [NorepinephrineIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.norepinephrineIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [NorepinephrineIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.norepinephrineIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.pdeInhibitorActiveIngredientMessages = {
    [PdeInhibitorActiveIngredient.PDE_INHIBITOR]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.pdeInhibitorActiveIngredient.PDE_INHIBITOR",
        defaultMessage: "PDE inhibitor"
    }
};
exports.pdeInhibitorIntakeTypeMessages = {
    [PdeInhibitorIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.pdeInhibitorIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [PdeInhibitorIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.pdeInhibitorIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.levosimendanActiveIngredientMessages = {
    [LevosimendanActiveIngredient.LEVOSIMENDAN]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.levosimendanActiveIngredient.LEVOSIMENDAN",
        defaultMessage: "Levosimendan"
    }
};
exports.levosimendanIntakeTypeMessages = {
    [LevosimendanIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.levosimendanIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [LevosimendanIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.levosimendanIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.antibioticIntakeTypeMessages = {
    [AntibioticIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.antibioticIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [AntibioticIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.antibioticIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
exports.otherIntakeTypeMessages = {
    [OtherIntakeType.ORAL_ROUTE]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.otherIntakeType.ORAL_ROUTE",
        defaultMessage: "p.o."
    },
    [OtherIntakeType.INTRAVENOUS]: {
        id: "basicHealth.currentCardiologicalState.heartFailureMedicalTherapy.otherIntakeType.INTRAVENOUS",
        defaultMessage: "i.v."
    }
};
const aceiActiveIngredient = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AceiActiveIngredient.CAPTOPRIL),
    schema_1.Schema.singleChoiceItem(AceiActiveIngredient.ENALAPRIL),
    schema_1.Schema.singleChoiceItem(AceiActiveIngredient.LISINOPRIL),
    schema_1.Schema.singleChoiceItem(AceiActiveIngredient.RAMIPRIL),
    schema_1.Schema.singleChoiceItem(AceiActiveIngredient.TRANDOLAPRIL),
    schema_1.Schema.singleChoiceItem(AceiActiveIngredient.OTHER)
]);
const aceiOtherIngredientName = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../activeIngredient} === "other"`), schema_1.Schema.string());
const aceiIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AceiIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(AceiIntakeType.INTRAVENOUS)
]).default(AceiIntakeType.ORAL_ROUTE);
const aceiDose = schema_1.Schema.string();
const acei = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: aceiActiveIngredient,
    otherIngredientName: aceiOtherIngredientName,
    intakeType: aceiIntakeType,
    dose: aceiDose
}))
    .interpretation({ vocab: "basic_health", code: "acei" })
    .tag({ vocab: "snomed", code: "372733002" });
const bblActiveIngredient = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(BblActiveIngredient.BISOPROLOL),
    schema_1.Schema.singleChoiceItem(BblActiveIngredient.CARVEDILOL),
    schema_1.Schema.singleChoiceItem(BblActiveIngredient.METOPROLOL_SUCCINATE),
    schema_1.Schema.singleChoiceItem(BblActiveIngredient.NEBIVOLOL),
    schema_1.Schema.singleChoiceItem(BblActiveIngredient.OTHER)
]);
const bblOtherIngredientName = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../activeIngredient} === "other"`), schema_1.Schema.string());
const bblIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(BblIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(BblIntakeType.INTRAVENOUS)
]).default(BblIntakeType.ORAL_ROUTE);
const bblDose = schema_1.Schema.string();
const bbl = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: bblActiveIngredient,
    otherIngredientName: bblOtherIngredientName,
    intakeType: bblIntakeType,
    dose: bblDose
}))
    .interpretation({ vocab: "basic_health", code: "bbl" })
    .tag({ vocab: "snomed", code: "373254001" });
const arbActiveIngredient = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(ArbActiveIngredient.CANDESARTAN),
    schema_1.Schema.singleChoiceItem(ArbActiveIngredient.VALSARTAN),
    schema_1.Schema.singleChoiceItem(ArbActiveIngredient.LOSARTAN),
    schema_1.Schema.singleChoiceItem(ArbActiveIngredient.OTHER)
]);
const arbOtherIngredientName = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../activeIngredient} === "other"`), schema_1.Schema.string());
const arbIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(ArbIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(ArbIntakeType.INTRAVENOUS)
]).default(ArbIntakeType.ORAL_ROUTE);
const arbDose = schema_1.Schema.string();
const arb = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: arbActiveIngredient,
    otherIngredientName: arbOtherIngredientName,
    intakeType: arbIntakeType,
    dose: arbDose
}))
    .interpretation({ vocab: "basic_health", code: "arb" })
    .tag({ vocab: "snomed", code: "372913009" });
const mraActiveIngredient = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(MraActiveIngredient.EPLERENON),
    schema_1.Schema.singleChoiceItem(MraActiveIngredient.SPIRONOLACTON),
    schema_1.Schema.singleChoiceItem(MraActiveIngredient.OTHER)
]);
const mraOtherIngredientName = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../activeIngredient} === "other"`), schema_1.Schema.string());
const mraIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(MraIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(MraIntakeType.INTRAVENOUS)
]).default(MraIntakeType.ORAL_ROUTE);
const mraDose = schema_1.Schema.string();
const mra = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: mraActiveIngredient,
    otherIngredientName: mraOtherIngredientName,
    intakeType: mraIntakeType,
    dose: mraDose
}))
    .interpretation({ vocab: "basic_health", code: "mra" })
    .tag({ vocab: "snomed", code: "372603003" });
const arniActiveIngredient = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(ArniActiveIngredient.SACUBITRIL_VALSARTAN),
    schema_1.Schema.singleChoiceItem(ArniActiveIngredient.OTHER)
]);
const arniOtherIngredientName = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../activeIngredient} === "other"`), schema_1.Schema.string());
const arniIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(ArniIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(ArniIntakeType.INTRAVENOUS)
]).default(ArniIntakeType.ORAL_ROUTE);
const arniDose = schema_1.Schema.string();
const arni = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: arniActiveIngredient,
    otherIngredientName: arniOtherIngredientName,
    intakeType: arniIntakeType,
    dose: arniDose
}))
    .interpretation({ vocab: "basic_health", code: "arni" })
    .tag({ vocab: "snomed", code: "777480008" });
const ivabradineActiveIngredient = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(IvabradineActiveIngredient.IVABRADINE)
]);
const ivabradineIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(IvabradineIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(IvabradineIntakeType.INTRAVENOUS)
]).default(IvabradineIntakeType.ORAL_ROUTE);
const ivabradineDose = schema_1.Schema.string();
const ivabradine = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: ivabradineActiveIngredient,
    intakeType: ivabradineIntakeType,
    dose: ivabradineDose
}))
    .interpretation({ vocab: "basic_health", code: "ivabradine" })
    .tag({ vocab: "snomed", code: "421228002" });
const diureticActiveIngredient = schema_1.Schema.string();
const diureticIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(DiureticIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(DiureticIntakeType.INTRAVENOUS)
]);
const diureticDose = schema_1.Schema.string();
const diuretic = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: diureticActiveIngredient,
    intakeType: diureticIntakeType,
    dose: diureticDose
}))
    .interpretation({ vocab: "basic_health", code: "diuretic" })
    .tag({ vocab: "snomed", code: "372695000" });
const antiarrhythmicAgentActiveIngredient = schema_1.Schema.string();
const antiarrhythmicAgentIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AntiarrhythmicAgentIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(AntiarrhythmicAgentIntakeType.INTRAVENOUS)
]);
const antiarrhythmicAgentDose = schema_1.Schema.string();
const antiarrhythmicAgent = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: antiarrhythmicAgentActiveIngredient,
    intakeType: antiarrhythmicAgentIntakeType,
    dose: antiarrhythmicAgentDose
}))
    .interpretation({ vocab: "basic_health", code: "antiarrhythmic_agent" })
    .tag({ vocab: "snomed", code: "372813008" });
const anticoagulantActiveIngredient = schema_1.Schema.string();
const anticoagulantIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AnticoagulantIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(AnticoagulantIntakeType.INTRAVENOUS)
]);
const anticoagulantDose = schema_1.Schema.string();
const anticoagulant = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: anticoagulantActiveIngredient,
    intakeType: anticoagulantIntakeType,
    dose: anticoagulantDose
}))
    .interpretation({ vocab: "basic_health", code: "anticoagulant" })
    .tag({ vocab: "snomed", code: "372862008" });
const trombocytaAggregationInhibitorActiveIngredient = schema_1.Schema.string();
const trombocytaAggregationInhibitorIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(TrombocytaAggregationInhibitorIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(TrombocytaAggregationInhibitorIntakeType.INTRAVENOUS)
]);
const trombocytaAggregationInhibitorDose = schema_1.Schema.string();
const trombocytaAggregationInhibitor = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: trombocytaAggregationInhibitorActiveIngredient,
    intakeType: trombocytaAggregationInhibitorIntakeType,
    dose: trombocytaAggregationInhibitorDose
}))
    .interpretation({
    vocab: "basic_health",
    code: "trombocyta_aggregation_inhibitor"
})
    .tag({ vocab: "snomed", code: "771452004" });
const statinActiveIngredient = schema_1.Schema.string();
const statinIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(StatinIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(StatinIntakeType.INTRAVENOUS)
]);
const statinDose = schema_1.Schema.string();
const statin = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: statinActiveIngredient,
    intakeType: statinIntakeType,
    dose: statinDose
}))
    .interpretation({ vocab: "basic_health", code: "statin" })
    .tag({ vocab: "snomed", code: "315053001" });
const allopurinolActiveIngredient = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AllopurinolActiveIngredient.ALLOPURINOL)
]);
const allopurinolIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AllopurinolIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(AllopurinolIntakeType.INTRAVENOUS)
]);
const allopurinolDose = schema_1.Schema.string();
const allopurinol = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: allopurinolActiveIngredient,
    intakeType: allopurinolIntakeType,
    dose: allopurinolDose
}))
    .interpretation({ vocab: "basic_health", code: "allopurinol" })
    .tag({ vocab: "snomed", code: "387135004" });
const digitalisActiveIngredient = schema_1.Schema.string();
const digitalisIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(DigitalisIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(DigitalisIntakeType.INTRAVENOUS)
]);
const digitalisDose = schema_1.Schema.string();
const digitalis = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: digitalisActiveIngredient,
    intakeType: digitalisIntakeType,
    dose: digitalisDose
}))
    .interpretation({ vocab: "basic_health", code: "digitalis" })
    .tag({ vocab: "snomed", code: "387521006" });
const dopamineActiveIngredient = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(DopamineActiveIngredient.DOPAMINE)
]);
const dopamineIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(DopamineIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(DopamineIntakeType.INTRAVENOUS)
]);
const dopamineDose = schema_1.Schema.string().unit("microg/kg/min");
const dopamine = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: dopamineActiveIngredient,
    intakeType: dopamineIntakeType,
    dose: dopamineDose
}))
    .interpretation({ vocab: "basic_health", code: "dopamine" })
    .tag({ vocab: "snomed", code: "412383006" });
const dobutamineActiveIngredient = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(DobutamineActiveIngredient.DOBUTAMINE)
]);
const dobutamineIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(DobutamineIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(DobutamineIntakeType.INTRAVENOUS)
]);
const dobutamineDose = schema_1.Schema.string().unit("microg/kg/min");
const dobutamine = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: dobutamineActiveIngredient,
    intakeType: dobutamineIntakeType,
    dose: dobutamineDose
}))
    .interpretation({ vocab: "basic_health", code: "dobutamine" })
    .tag({ vocab: "snomed", code: "387145002" });
const norepinephrineActiveIngredient = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(NorepinephrineActiveIngredient.NOREPINEPHRINE)
]);
const norepinephrineIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(NorepinephrineIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(NorepinephrineIntakeType.INTRAVENOUS)
]);
const norepinephrineDose = schema_1.Schema.string().unit("microg/kg/min");
const norepinephrine = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: norepinephrineActiveIngredient,
    intakeType: norepinephrineIntakeType,
    dose: norepinephrineDose
}))
    .interpretation({
    vocab: "basic_health",
    code: "adrenalin_or_noradrenalin"
});
const pdeInhibitorActiveIngredient = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(PdeInhibitorActiveIngredient.PDE_INHIBITOR)
]);
const pdeInhibitorIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(PdeInhibitorIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(PdeInhibitorIntakeType.INTRAVENOUS)
]);
const pdeInhibitorDose = schema_1.Schema.string().unit("microg/kg/min");
const pdeInhibitor = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: pdeInhibitorActiveIngredient,
    intakeType: pdeInhibitorIntakeType,
    dose: pdeInhibitorDose
}))
    .interpretation({ vocab: "basic_health", code: "pde_inhibitor" });
const levosimendanActiveIngredient = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(LevosimendanActiveIngredient.LEVOSIMENDAN)
]);
const levosimendanIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(LevosimendanIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(LevosimendanIntakeType.INTRAVENOUS)
]);
const levosimendanDose = schema_1.Schema.string().unit("mg/week");
const levosimendan = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: levosimendanActiveIngredient,
    intakeType: levosimendanIntakeType,
    dose: levosimendanDose
}))
    .interpretation({ vocab: "basic_health", code: "levosimendan" })
    .tag({ vocab: "snomed", code: "442795003" });
const antibioticActiveIngredient = schema_1.Schema.string();
const antibioticIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AntibioticIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(AntibioticIntakeType.INTRAVENOUS)
]);
const antibioticDose = schema_1.Schema.string();
const antibiotic = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: antibioticActiveIngredient,
    intakeType: antibioticIntakeType,
    dose: antibioticDose
}))
    .interpretation({ vocab: "basic_health", code: "antibiotic" })
    .tag({ vocab: "snomed", code: "281789004" });
const otherActiveIngredient = schema_1.Schema.string();
const otherIntakeType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(OtherIntakeType.ORAL_ROUTE),
    schema_1.Schema.singleChoiceItem(OtherIntakeType.INTRAVENOUS)
]);
const otherDose = schema_1.Schema.string();
const other = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().properties({
    activeIngredient: otherActiveIngredient,
    intakeType: otherIntakeType,
    dose: otherDose
}))
    .interpretation({
    vocab: "basic_health",
    code: "heart_failure_medical_therapy_other_medicine"
});
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({
    acei,
    bbl,
    arb,
    mra,
    arni,
    ivabradine,
    diuretic,
    antiarrhythmicAgent,
    anticoagulant,
    trombocytaAggregationInhibitor,
    statin,
    allopurinol,
    digitalis,
    dopamine,
    dobutamine,
    norepinephrine,
    pdeInhibitor,
    levosimendan,
    antibiotic,
    other
})
    .interpretation({
    vocab: "basic_health",
    code: "heart_failure_medical_therapy"
})
    .tag({ vocab: "snomed", code: "308118002" });
